export default __webpack_public_path__ + "static/media/photo12.c964e460.jpg";